module.exports = __webpack_public_path__ + "img/pennellata-come-usare-per.95a45f87.jpg";